const NOT_ALLOWED_CHARACTERS_EXPR = /\s|-/g;

const formatTelephoneLink = phone => `tel:${phone.replace(NOT_ALLOWED_CHARACTERS_EXPR, '')}`;

export default formatTelephoneLink;
